import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SplitPane from 'react-split-pane';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as currentStatusActions from 'modules/currentStatus';

import classNames from 'classnames/bind';
import styles from './SplitPaneTemplate.css';
const cx = classNames.bind(styles);

let resizeLayout;
// main의 layout 간격 템플릿
class SplitPaneTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = { maxSize: 0 };

    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.contentPageHeight(this.contentPageRef.clientHeight - 90);

    window.addEventListener('resize', this.onResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  // 브라우저 리사이즈시의 처리
  onResize = () => {
    clearTimeout(resizeLayout);
    resizeLayout = setTimeout(() => {
      this.forceUpdate();
    }, 300);
  };

  render() {
    const { list, listData, detail } = this.props;

    let maxSize = 1000;
    if (!!this.contentPageRef && 1600 < this.contentPageRef.clientWidth) {
      maxSize = this.contentPageRef.clientWidth - 600;
    }

    return (
      <div className={cx('splitPane-wrapper')} ref={ref => (this.contentPageRef = ref)}>
        {/* <SplitPane split="vertical" step={10} defaultSize={900} minSize={900} maxSize={maxSize}> */}
        {/* primary="second"> */}
        {/* 가운데 영역 */}
        <div className={cx('splitPane-listData')}>{listData}</div>
        {/* 오른쪽 영역 */}
        <div className={cx('splitPane-detail')}>{detail}</div>
        {/* </SplitPane> */}
      </div>
    );
  }
}

SplitPaneTemplate.propTypes = {};

const mapDispatchToProps = dispatch => ({
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(SplitPaneTemplate);



// WEBPACK FOOTER //
// ./src/script/components/template/SplitPaneTemplate.js